import { animate, animation, keyframes, style, transition, trigger, useAnimation } from '@angular/animations';

export enum CarouselBoostAnimationState {
    Selected = 'selected',
}

const factorTemplateAnimation = animation([
    animate(
        '.4s ease-in-out',
        keyframes([
            style({ transform: '{{ scale-1 }}', opacity: 0.1, offset: 0 }),
            style({ transform: '{{ scale-2 }}', opacity: 0.7, offset: 0.6 }),
            style({ transform: '{{ scale-3 }}', opacity: 1, offset: 1 }),
        ]),
    ),
]);

const factorAnimation = useAnimation(factorTemplateAnimation, {
    params: {
        'scale-1': 'scale(0.6)',
        'scale-2': 'scale(1.1)',
        'scale-3': 'scale(1)',
    },
});

const maxFactorAnimation = useAnimation(factorTemplateAnimation, {
    params: {
        'scale-1': 'scale(0.8)',
        'scale-2': 'scale(1.03)',
        'scale-3': 'scale(1)',
    },
});

export const boostFactorAnimation = [trigger('boostFactorAnimation', [transition(boostFactorChanged, [factorAnimation])])];

function boostFactorChanged(previousBoostFactor: string, currentBoostFactor: string): boolean {
    return !!currentBoostFactor && currentBoostFactor !== 'void' && previousBoostFactor !== currentBoostFactor;
}

export const carouselFactorAnimation = [
    trigger('carouselFactorAnimation', [transition(selectedMode, [factorAnimation])]),
    trigger('carouselMaxFactorAnimation', [transition(selectedMode, [maxFactorAnimation])]),
];

function selectedMode(previousPosition: string, currentPosition: string): boolean {
    return currentPosition === CarouselBoostAnimationState.Selected.toString();
}

export const notificationBubbleAnimation = [
    trigger('notificationBubbleAnimation', [
        transition(':enter', [
            style({ transform: 'translateY(0)', opacity: 0 }),
            animate('300ms 150ms ease-in-out', style({ transform: 'translateY(-120%)', opacity: 1 })),
        ]),
        transition(':leave', [
            style({ transform: 'translateY(-120%)', opacity: 1 }),
            animate('110ms ease-in-out', style({ transform: 'translateY(0)', opacity: 0 })),
        ]),
    ]),
];
